import { fetchBiUsableUploads } from '@euler/functions/bi/fetchBiUsableUploads';
import { BiUploadedDatasetView } from '@euler/model/bi/dataset';
import { useServiceFactory } from '@euler/services/factory';
import { useEffect, useState } from 'react';

export type BiUsableDatasetsState =
  | { kind: 'loading' }
  | { kind: 'ready'; datasets: BiUploadedDatasetView[] }
  | { kind: 'failed' };

/** The uploaded datasets the caller can use: their own, then shared. */
export function useBiUsableDatasets(): BiUsableDatasetsState {
  const { biService } = useServiceFactory();
  const [state, setState] = useState<BiUsableDatasetsState>({
    kind: 'loading',
  });
  useEffect(() => {
    let active = true;
    fetchBiUsableUploads(biService)
      .then(datasets => {
        if (active) setState({ kind: 'ready', datasets });
      })
      .catch(error => {
        console.error('BI usable datasets failed', error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [biService]);
  return state;
}
